<template>
  <div>
    <v-alert prominent type="warning" v-if="isAccepted">
      <v-row align="center" dense>
        <v-col class="grow">Заказ находится в очереди на регистрацию</v-col>
        <v-col class="shrink">
          <!--
          <v-btn text>отменить регистрацию</v-btn>
        -->
        </v-col>
      </v-row>
    </v-alert>
    <v-alert prominent type="error" v-if="isError || isUnknown">
      <v-row align="center" dense>
        <v-col class="grow" v-if="isError"
          >При регистрации чека произошла неустранимая ошибка</v-col
        >
        <v-col class="grow" v-if="isUnknown"
          >Чек Шрёденгера: касса не вернула ответ, результат регистрации
          неизвестен</v-col
        >
      </v-row>
    </v-alert>
    <v-card v-if="order">
      <v-card-text>
        <OrderForm
          v-model="order"
          :clientId="clientId"
          :disabled="isDisabled"
        />
      </v-card-text>
      <v-card-actions v-if="!isDisabled">
        <v-row dense>
          <v-col class="shrink">
            <v-btn
              class="green"
              :disabled="!isValid || disabled"
              :dark="isValid"
              @click="save"
            >
              Сохранить
            </v-btn>
          </v-col>
          <v-col class="grow">
            <v-btn text @click="cancel">закрыть</v-btn>
          </v-col>
          <v-col class="shrink" v-if="isRemovable">
            <confirmation-dialog
              @confirm="remove"
              title="Удалить заказ?"
              color="red"
              :disabled="!confirmRemove"
            >
              <template #text>
                Заказ будет удалён без возможности восстановления.
                <v-checkbox
                  label="подтверждаю удаление"
                  v-model="confirmRemove"
                ></v-checkbox>
              </template>
              <template #activator="{ on }">
                <v-btn text color="red" v-on="on">
                  Удалить
                </v-btn>
              </template>
            </confirmation-dialog>
          </v-col>
          <v-col class="shrink">
            <v-btn
              class="primary"
              :disabled="!isValid || disabled"
              @click="registration"
            >
              Зарегистрировать чек
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import ds from "@/datastore";
import OrderForm from "@/components/ui/forms/OrderForm";
export default {
  name: "OrderEdit",
  components: { OrderForm },
  props: {
    order: Object,
    parentId: String,
    clientId: String
  },
  data() {
    return {
      disabled: false,
      confirmRemove: false
    };
  },
  computed: {
    isValid() {
      return this.order.isValid();
    },
    isAccepted() {
      return this.order && this.order.status === "accepted";
    },
    isError() {
      return this.order && this.order.status === "failed";
    },
    isUnknown() {
      return this.order && this.order.status === "unknown";
    },
    isDisabled() {
      return (
        this.disabled ||
        !this.order ||
        (this.order.status && this.order.status !== "created")
      );
    },
    isRemovable() {
      return !this.isDisabled && this.order.status;
    }
  },
  methods: {
    cancel() {
      this.$destroy();
      this.$router.go(-1);
    },
    async save() {
      if (!this.validatePaymentAmount()) {
        return;
      }
      let order;
      if (this.order.status) {
        order = await this.order.save({ noValidate: true });
      } else {
        order = await ds.create("order", this.order, { noValidate: true });
      }
      this.$store.commit("notifications/success", "Заказ сохранен.");
      this.cancel();
      return order;
    },
    async remove() {
      if (!this.isRemovable) {
        return;
      }
      await this.order.destroy();
      this.$store.commit("notifications/success", "Заказ удалён.");
      this.cancel();
    },
    async registration() {
      if (!this.validatePaymentAmount()) {
        return;
      }
      try {
        this.disabled = true;
        let status = await this.order.registration({
          timeout: 20,
          mandatory: true
        });
        if (status.status === "processed") {
          this.$store.commit(
            "notifications/success",
            "Чек успешно сформирован"
          );
          await this.navigateDetails();
        }
      } finally {
        this.disabled = false;
      }
    },
    async navigateDetails() {
      try {
        await this.$router.replace({
          name: "order-details",
          params: { groupId: this.order.groupId, orderId: this.order.orderId }
        });
      } catch (e) {
        if (e.name !== "NavigationDuplicated") {
          throw e;
        }
      }
    },
    validatePaymentAmount() {
      return (
        this.order.validatePaymentAmount() ||
        this.$store.commit(
          "notifications/error",
          "Введеная сумма оплаты не совпадает с суммой предметов расчета"
        )
      );
    }
  }
};
</script>
